import { useDispatch } from 'react-redux';

import type { AppDispatch } from '../reducers/index.js';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
